// extracted by mini-css-extract-plugin
module.exports = {"form":"form--GHep7","reminder":"reminder--K+QgW","button":"button--QQxZ5"};